import { Divider, Drawer } from '@material-ui/core';
import { X } from 'lucide-react';
import { FC, ReactNode } from 'react';
import { useThemeContext } from 'shared/context/themeContext';
import {
  dark as darkColors,
  light as lightColors
} from 'shared/theme/colorTokens';
import TrashAllFilters from './TrashAllFilters';

interface FiltersDrawerProps {
  open: boolean;
  onClose: () => void;
  /** Si se omite, no se muestra el icono de limpiar filtros. */
  onClear?: () => void;
  title?: ReactNode;
  children: ReactNode;
  /** Ancho del drawer (cualquier valor CSS). */
  width?: string;
  /** Persistente: sin backdrop, la tabla sigue visible mientras se filtra. */
  persistent?: boolean;
}

const FiltersDrawer: FC<FiltersDrawerProps> = ({
  open,
  onClose,
  onClear,
  title = 'Filtros',
  children,
  width = '28rem',
  persistent = true
}) => {
  const { theme } = useThemeContext();
  const isDark = theme === 'dark';

  return (
    <Drawer
      anchor="right"
      open={open}
      variant={persistent ? 'persistent' : 'temporary'}
      onClose={persistent ? undefined : onClose}
      transitionDuration={300}
      PaperProps={{
        style: {
          width,
          maxWidth: '100vw',
          backgroundColor: isDark
            ? darkColors.modalBackground
            : lightColors.modalBackground
        }
      }}
    >
      <div className="flex h-full flex-col">
        <div className="flex items-center justify-between px-6 py-3">
          <h2 className="text-lg font-semibold text-ink dark:text-ink-dark">
            {title}
          </h2>
          <div className="flex items-center gap-1">
            {onClear && <TrashAllFilters onClick={onClear} />}
            <button
              type="button"
              title="Cerrar filtros"
              onClick={onClose}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full text-inkMuted transition hover:scale-110 hover:text-secondary-600 dark:text-inkMuted-dark dark:hover:text-secondary-300"
            >
              <X size={18} />
            </button>
          </div>
        </div>
        <Divider />
        <div className="flex-1 overflow-y-auto px-6 py-4">{children}</div>
      </div>
    </Drawer>
  );
};

export default FiltersDrawer;
